import {computed, makeAutoObservable} from "mobx";
import {shuffle} from "../Utils";

export enum QuestionRating {
    Correct = "Correct",
    Wrong = "Wrong",
    Maybe = "Maybe"
}

export default class Question {
    private _question: string;

    private _options: Map<string, QuestionRating>;

    constructor(question: string, options: Map<string, QuestionRating>) {
        this._question = question;
        this._options = new Map(options);
        makeAutoObservable(this);
    }

    @computed
    shuffledOptions(): {option: string, solution: QuestionRating}[] {
        return shuffle(Array.from(this._options));
    }

    get question(): string {
        return this._question;
    }

    set question(value: string) {
        this._question = value;
    }

    get options(): Map<string, QuestionRating> {
        return new Map(this._options);
    }

    set options(value: Map<string, QuestionRating>) {
        this._options = value;
    }
}